const PermissionType = {
  READ: "can_read",
  UPDATE: "can_update",
  DELETE: "can_delete",
  PERMIT: "can_permit",
};

export default PermissionType;
